export default "/assets/8785c64878653008.png"